import { lazy } from 'app/lazy'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'

const ErrorPage = lazy(() => import('features/errors/ui/ErrorPage'))
const DataExplorerPage = lazy(() => import('features/new-data-explorer/ui/DataExplorerPage'))

export const DATA_EXPLORER_ROUTE = '/data/explorer'

const routes = {
  path: 'data',
  element: <AuthenticatedRoute />,
  children: [
    {
      index: true,
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: ':tree',
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: ':tree/:connectionName',
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: ':tree/:connectionName/:projectId',
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: ':tree/:connectionName/:projectId/:datasetId',
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: ':tree/:connectionName/:projectId/:datasetId/:resourceId',
      element: (
        <LazyLoad>
          <DataExplorerPage />
        </LazyLoad>
      )
    },
    {
      path: 'invalid_connection/:code',
      element: (
        <LazyLoad>
          <ErrorPage code="404" />
        </LazyLoad>
      )
    },
    {
      path: 'non_existent_resource/:code',
      element: (
        <LazyLoad>
          <ErrorPage code="404" />
        </LazyLoad>
      )
    }
  ]
}
export default routes
